import React from "react";
import {
    TextField,
    SelectField,
    ArrayField,
    Datagrid,
    DateField
} from 'react-admin';

class QualificationArrayField extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <ArrayField {...this.props}>
                <Datagrid>
                    <SelectField label="Тип кваліфікації" source="type" choices={[
                        { id: 'POSTGRADUATE', name: 'Аспірантура' },
                        { id: 'REATTESTATION', name: 'Передатестаційний цикл' },
                        { id: 'SPECIALIZATION', name: 'Курси спеціалізації' },
                        { id: 'STAZHUVANNYA', name: 'Стажування' },
                    ]} />
                    <TextField label="Навчальний заклад" source="institutionName"  />
                    <TextField label="Вказати спеціальність" source="speciality"  />
                    <DateField label="Дата отримання сертифікату" source="issuedDate" />
                    <TextField label="Номер сертифікату" source="certificateNumber"  />
                    <DateField label="Дійсний до" source="validTo"  />
                </Datagrid>
            </ArrayField>
        );
    }
}

export default QualificationArrayField;
